import { useDropzone } from "react-dropzone";
import { Box, Button, TextField, Typography } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { useEffect, useRef, useCallback } from "react";

const AssetInputer = ({ method, file, setFile, fileURL, setFileURL, setName, setTags }) => {
    const dropzoneRef = useRef(null);

    const extractFromFilename = (filename) => {
        const parts = filename.replace(/\.[^/.]+$/, "").split(/[^a-zA-Z0-9]/).filter(Boolean);
        return {
            defaultName: parts.map(p => p[0].toUpperCase() + p.slice(1)).join(" "),
            defaultTags: parts.map(p => p.toLowerCase())
        };
    };

    const onFileAccepted = useCallback((selected) => {
        const { defaultName, defaultTags } = extractFromFilename(selected.name);
        setFile(selected);
        setName(defaultName);
        setTags(defaultTags);
    }, [setFile, setName, setTags]);

    const { getRootProps, getInputProps, open, isDragActive } = useDropzone({
        accept: {
            "image/png": [".png"],
            "font/ttf": [".ttf"]
        },
        multiple: false,
        noClick: true,
        onDrop: (acceptedFiles) => {
            if (acceptedFiles.length === 0) return;
            const selected = acceptedFiles[0];
            onFileAccepted(selected);
        }
    });

    // Handle paste events
    // useEffect(() => {
    //     if (method !== "file") return;

    //     const handlePaste = (e) => {
    //         e.preventDefault();
    //         const clipboardData = e.clipboardData || window.clipboardData;
    //         const items = clipboardData.items;

    //         for (let i = 0; i < items.length; i++) {
    //             const item = items[i];

    //             // Check if the item is a file
    //             if (item.kind === 'file') {
    //                 const file = item.getAsFile();

    //                 // Check if file type is accepted
    //                 const acceptedTypes = ['image/png', 'font/ttf'];
    //                 if (acceptedTypes.includes(file.type)) {
    //                     onFileAccepted(file);
    //                     break;
    //                 }
    //             }
    //         }
    //     };

    //     const dropzoneElement = dropzoneRef.current;
    //     if (dropzoneElement) {
    //         dropzoneElement.addEventListener('paste', handlePaste);
    //         // Make the element focusable to receive paste events
    //         dropzoneElement.setAttribute('tabindex', '0');
    //     }

    //     return () => {
    //         if (dropzoneElement) {
    //             dropzoneElement.removeEventListener('paste', handlePaste);
    //         }
    //     };
    // }, [method, onFileAccepted]); // Added onFileAccepted to dependency array

    if (method === "file") {
        return (
            <Box
                {...getRootProps()}
                ref={dropzoneRef}
                sx={{
                    border: file ? "2px solid #4caf50" : "2px dashed #888",
                    borderRadius: 2,
                    p: 3,
                    textAlign: "center",
                    backgroundColor: isDragActive ? "#f0f0f0" : "background.paper",
                    transition: "background-color 0.2s ease",
                    cursor: "pointer",
                    outline: "none", // Remove focus outline
                }}
            >
                <input {...getInputProps()} />
                <CloudUploadIcon sx={{ fontSize: 40, mb: 1 }} />
                <Typography>
                    {isDragActive ? "Drop the file here..." : "Drag & Drop a PNG or TTF file here"}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    or
                </Typography>
                <Button
                    variant="outlined"
                    sx={{ mt: 1 }}
                    onClick={open}
                >
                    Select File
                </Button>
                {file && (
                    <>
                        <Typography variant="body2" sx={{ fontWeight: 600, color: "#2e7d32" }}>
                            ✓ Selected: {file.name}
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                            Size: {(file.size / 1024).toFixed(2)} KB
                        </Typography>
                    </>
                )}
            </Box>
        );
    }

    if (method === "url") {
        return (
            <TextField
                label="Dropbox Folder or File Link"
                fullWidth
                value={fileURL}
                onChange={(e) => setFileURL(e.target.value)}
            />
        );
    }

    return null;
};

export default AssetInputer;